import { module } from 'modujs';

export default class extends module {
    constructor(m) {
        super(m);

    }

    init() {
        this.swiperImages = new Swiper(this.$('images')[0], {
            loop: false,
            speed: 1200,
            autoHeight: true,
            parallax: true,
            effect: 'creative',
            creativeEffect: {
                prev: {
                    shadow: false,
                    translate: [0, 0, -200],
                },
                next: {
                    translate: ['120%', 0, 0],
                },
            },
            pagination: {
                el: '.swiper-pagination',
                type: 'bullets',
                clickable: true
            }
        });

        this.swiperTitles = new Swiper(this.$('titles')[0], {
            loop: false,
            speed: 1200,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });

        this.swiperTexts = new Swiper(this.$('texts')[0], {
            loop: false,
            speed: 1200,
            effect: 'fade',
            fadeEffect: {
                crossFade: true
            },
        });

        this.swiperTitles.controller.control = this.swiperImages;
        this.swiperImages.controller.control = this.swiperTitles;

        this.swiperImages.on('slideChange',() => {
            let index = this.swiperImages.realIndex;
            this.swiperTexts.slideToLoop(index);
        });

    }

    destroy() {
        if(this.swiper !== undefined) {
            this.swiper.destroy()
        }
    }
}